export const state = {
  searchLoading: false,
  search: {
    keyword: '',
    filters: [],
    mode: '',
    searchResults: [], // Displayed search results
    numHits: null, // Total search results found
    numDocs: null, // Total documents found
    numProducts: null, // Total products found
  },
  modal: {
    filters: [],
    query: '',
    mode: '',
    offset: '',
    actionDateStart: '',
    actionDateEnd: '',
  },
  showAnalytics: false,
  tabIndex: 1,
  savedSearch: [],
};
